<div class="outer-container">
    <div class="background-img-container">
        <div class="header-container">
            <app-header *ngIf="!showSuccess"></app-header>
        </div>

        <div class="content-container">
            <div class="content">
                <div class="ic-form-container" *ngIf="!showSuccess && !showMobileOtpVerification && !showEmailOtpVerification && !showPin">
                    <div class="heading">{{'forgetPin.enterICNumber' | translate}}</div>
                    <form #ngForm (ngSubmit)="icNumberNextClick()" class="ic-form">
                        <div class="form-group">
                            <label class="no-mark color-fff field-label">
                                {{"forgetPin.ICNumber" | translate}}
                            </label>
                            <input class="border-none txtbox-bg-input" maxlength="12" minlength="12" type="text" [(ngModel)]="icNumber" [ngModelOptions]="{standalone: true}"
                                placeholder="{{ 'login.ICNumberPlaceholder' | translate }}" (keypress)="isNumberKey($event)">
                        </div>

                        <button class="primary-button cursor-pointer" [disabled]="!icNumber || icNumber.length != 12">{{
                            'forgetPin.next' | translate
                            }}</button>
                    </form>
                </div>

                <div class="otp-verification-container" *ngIf="showMobileOtpVerification || showEmailOtpVerification">
                    <div class="img-container">
                        <img *ngIf="showMobileOtpVerification" src="./images/otp.svg">
                        <img *ngIf="showEmailOtpVerification" src="./images/email.svg">
                        <img *ngIf="showPin" src="./images/pin.svg">
                    </div>
                    <div class="enter-code" *ngIf="showMobileOtpVerification || showEmailOtpVerification">{{'verifyOtp.enterCode' | translate}}</div>
                    <div class="link" *ngIf="showMobileOtpVerification">{{userDetails?.mobileNo}}</div>
                    <div class="link" *ngIf="showEmailOtpVerification">{{userDetails?.userEmail}}</div>
                    <form #ngForm (ngSubmit)="verifyOtp()" class="otp-container">
                        <div class="form-container">
                            <ng-otp-input #otpInput [config]="{length:4,allowNumbersOnly:true}"
                                (onInputChange)="onOtpChange($event)">
                            </ng-otp-input>
                            <div class="display-b" *ngIf="!displayResendCode"
                                [ngClass]="{'display-n': displayResendCode}">
                                <p class="resend-txt">{{ 'verifyOtp.resend' | translate }}: <span id="time">02:00</span>
                                </p>
                            </div>

                            <div class="resend-txt-active cursor-pointer" *ngIf="displayResendCode" (click)="resendClick()">{{ 'verifyOtp.resend' | translate
                                }}</div>
                        </div>
                        <button type="submit" class="primary-button cursor-pointer" [disabled]="otp?.length < 4">{{
                            'verifyOtp.verify' | translate
                            }}</button>
                    </form>
                </div>

                <div class="pin-container" *ngIf="showPin">
                    <div class="img-container">
                        <img src="./images/pin.svg">
                    </div>
                    <div class="create-pin" *ngIf="showCreatePin">{{'forgetPin.createPin' | translate}}</div>
                    <div class="create-pin-content" *ngIf="showCreatePin">{{'forgetPin.createPinContent' | translate}}</div>
                    <div class="create-pin" *ngIf="showConfirmPin">{{'forgetPin.confirmPin' | translate}}</div>
                    <div class="create-pin-content" *ngIf="showConfirmPin">{{'forgetPin.confirmPinContent' | translate}}</div>
                    <form #ngForm (ngSubmit)="confirmPinClick()" class="otp-container">
                        <div class="form-container">
                            <ng-otp-input #otpInput1 [config]="{length:6,allowNumbersOnly:true}"
                                (onInputChange)="onPinChange($event)">
                            </ng-otp-input>
                        </div>
                        <button type="submit" class="primary-button cursor-pointer" [disabled]="((showCreatePin && (!createPin || createPin.length < 6)) || (showConfirmPin && (!confirmPin || confirmPin.length < 6)))">{{
                            'forgetPin.next' | translate
                            }}</button>
                    </form>
                </div>

                
                <button class="secondary-button cursor-pointer" *ngIf="!showSuccess" (click)="backClick()">{{
                    'forgetPin.back' | translate
                    }}</button>

                <div class="successData" *ngIf="showSuccess">
                    <app-success [successData]="successData"></app-success>
                </div>
            </div>
        </div>
    </div>
</div>